import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'A chi è rivolta questa biblioteca?',
  answer: 'A chi usa i tarocchi, il Reiki o i chakra, da soli o insieme, e vuole sedute organizzate, con schede, schemi e tavole pronti da stampare.'
}, {
  question: 'Devo già praticare tutte e tre?',
  answer: 'No. La guida «Inizia da qui» propone un ordine di lettura: ogni volume spiega la sua pratica passo per passo, poi il Volume 6 le unisce nella seduta integrata.'
}, {
  question: 'I tarocchi servono a prevedere il futuro?',
  answer: 'No. Qui i tarocchi sono presentati come strumento di riflessione e di dialogo, secondo la tradizione marsigliese. Nessuna carta annuncia un evento.'
}, {
  question: 'Sostituisce il medico o lo psicologo?',
  answer: 'No. Tarocchi, Reiki e chakra sono presentati come pratiche di benessere e di riflessione secondo le tradizioni: nessuna diagnosi, e nulla sostituisce il parere del medico o dello psicologo. La guida spiega anche quando indirizzare la persona a un professionista sanitario.'
}, {
  question: 'Sostituisce un corso di Reiki?',
  answer: 'No. È un supporto didattico: non rilascia attestati e non sostituisce l’insegnamento di un Master Reiki.'
}, {
  question: 'Posso davvero stampare le schede?',
  answer: 'Sì. Le 60 schede sono pagine A4: stampale a casa o in copisteria, tutte le volte che ti servono.'
}, {
  question: 'Come ricevo la biblioteca?',
  answer: 'Subito dopo il pagamento ricevi un’email con l’accesso ai tuoi PDF: i 6 volumi, le 60 schede, la guida «Inizia da qui» e i 5 bonus. Scaricali sul computer, sul tablet o sul telefono.'
}, {
  question: 'I 5 bonus sono davvero in regalo?',
  answer: 'Sì. Sono inclusi con il tuo sistema, senza nessun costo aggiuntivo.'
}, {
  question: 'È un abbonamento?',
  answer: 'No. È un pagamento unico, senza abbonamento e senza costi nascosti.'
}, {
  question: 'E se ho un problema di accesso?',
  answer: 'Scrivi a defgrup.soporte@gmail.com indicando l’indirizzo email usato per l’acquisto. Il tuo acquisto è coperto dalla protezione dell’acquirente di 7 giorni descritta sopra.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-55" data-mp="38lrb4xkqdbo4"><div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-56" data-mp="38kzfxnv1pfyd"><button className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-57" data-mp="33npqw9bkj6b2"><span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-58" data-mp="2ypehu0t3kztw">?</span><span className="flex-1 font-semibold text-navy" data-id="element-59" data-mp="1n86e7hq9znqs">{item.question}</span><ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-60" data-mp="1n9he36globcm" /></button><AnimatePresence initial={false} data-id="element-61" data-mp="1j8xk2brbpnup">{open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22
        }} data-id="element-62" data-mp="3uupqr0g6s4kb"><p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-63" data-mp="2nrgmd999gak">{item.answer}</p></motion.div>}</AnimatePresence></div></Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-64" data-mp="ch8bzlp1j3gc"><div className="mx-auto max-w-3xl" data-id="element-65" data-mp="hftangon9f2o"><Reveal className="text-center" data-id="element-66" data-mp="heqmvhmmbsqz"><h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-67" data-mp="me39c19kuxt1">❓ Domande <span className="text-sage" data-id="element-68" data-mp="mc9zye7kxzhc">frequenti</span></h2><p className="mt-5 text-slate" data-id="element-69" data-mp="qfyb16vf7d7c">Tutto quello che vuoi sapere prima di ordinare.</p></Reveal><div className="mt-10 space-y-3" data-id="element-70" data-mp="vej9p1v0xoto">{faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-71" data-mp="ve9kvhlptnpk" data-mpi={index} />)}</div></div></section>;
}